import React from 'react';
import { css } from 'emotion';
import { Link } from 'react-router-dom';
import insyncLogo from '../../assets/insyncLogo.svg';

const headerStyle = css`
  grid-area: header;
  position: sticky;
  top: 0;
  background: var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2.25rem;
  z-index: 4;
  border-bottom: 1px solid var(--primaryBrand);
`;

const logoStyle = css`
  height: 1.75rem;
  @media (max-width: 768px) {
    height: 1.125rem;
  }
`;

export const Header = () => (
  <header className={headerStyle}>
    <Link to="/">
      <img src={insyncLogo} alt="logo" className={logoStyle} />
    </Link>
  </header>
);
